import { putPasswordsRepository } from "../Infrastructure/ResetPassword.repository";

export async function putPasswordsRepositoryLogic(id, params) {
  return await putPasswordsRepository(id, params);
}
